import { CSSResult, unsafeCSS } from 'lit'


export const wrapCustomCss = (customCss: object): Record<string, CSSResult> => {
  return Object.fromEntries(
    Object.entries(customCss)
      .map(([key, value]) => [key, unsafeCSS(value)]),
  )
}
